// Decoder for the iteration-1.9 projectile packet. Mirrors
// backend/wire/projectile.go.
//
// Packet shape (little-endian):
//   header (32 bytes):
//     server_tick    u32
//     ship_uuid      16 bytes
//     x_origin       i32 (×4 scale, world units)
//     y_origin       i32 (×4 scale)
//     record_count   u8
//     reserved       3 bytes
//
//   each record (14 bytes):
//     projectile_id  u16
//     spawn_tick     u32
//     lifetime_ticks u16
//     sprite_id      u8
//     reserved       1 byte
//     vx             i16 (×10 scale, world-units/tick)
//     vy             i16 (×10 scale)

export const ProjectilePacketHeaderBytes = 32
export const ProjectileRecordBytes = 14
export const PosWireScale = 4
export const VelWireScale = 10

// uuidToString converts a 16-byte raw UUID into the canonical
// 8-4-4-4-12 hex string. Matches Go's uuid.UUID.String() output.
function uuidToString(bytes, offset) {
  const hex = []
  for (let i = 0; i < 16; i++) {
    hex.push(bytes[offset + i].toString(16).padStart(2, '0'))
  }
  return (
    hex.slice(0, 4).join('') + '-' +
    hex.slice(4, 6).join('') + '-' +
    hex.slice(6, 8).join('') + '-' +
    hex.slice(8, 10).join('') + '-' +
    hex.slice(10, 16).join('')
  )
}

// decodeProjectilePacket takes the raw DC payload (already stripped of the
// 1-byte FrameKind prefix) and returns { header, records } or null on
// malformed input.
export function decodeProjectilePacket(buf) {
  if (buf.byteLength < ProjectilePacketHeaderBytes) return null
  const view = new DataView(buf)
  const u8 = new Uint8Array(buf)
  const serverTick = view.getUint32(0, true)
  const shipUUID = uuidToString(u8, 4)
  const xOrigin = view.getInt32(20, true)
  const yOrigin = view.getInt32(24, true)
  const recordCount = view.getUint8(28)
  const expectedSize = ProjectilePacketHeaderBytes + recordCount * ProjectileRecordBytes
  if (buf.byteLength < expectedSize) return null
  const records = []
  for (let i = 0; i < recordCount; i++) {
    const o = ProjectilePacketHeaderBytes + i * ProjectileRecordBytes
    records.push({
      projectileId: view.getUint16(o, true),
      spawnTick: view.getUint32(o + 2, true),
      lifetimeTicks: view.getUint16(o + 6, true),
      spriteId: view.getUint8(o + 8),
      vx: view.getInt16(o + 10, true) / VelWireScale,
      vy: view.getInt16(o + 12, true) / VelWireScale,
    })
  }
  return {
    header: {
      serverTick,
      shipUUID,
      worldOriginX: xOrigin / PosWireScale,
      worldOriginY: yOrigin / PosWireScale,
      recordCount,
    },
    records,
  }
}
